// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.22-13276(4ceafa4953)-C14/10/2026-16:32:20-B14/10/2026-17:26:10' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.22-13276(4ceafa4953)-C14/10/2026-16:32:20-B14/10/2026-17:26:10",
  branch: "production",
  latestTag: "8.0.22",
  revCount: "13276",
  shortHash: "4ceafa4953",
  longHash: "4ceafa495391cea00d005a66f77535923d2c0fbc",
  dateCommit: "14/10/2026-16:32:20",
  dateBuild: "14/10/2026-17:26:10",
  buildType: "Ansible",
  } ;
